import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getNotificationPreferences(notificationPreferencesId) {
  return new NetworkRequestConfiguration({
    endpoint: `claims/portal/notification_preferences/${notificationPreferencesId}`,
    method: NetworkRequestConfiguration.Methods.GET,
  });
}

